var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"a-logo",attrs:{"href":_vm.homePath,"aria-label":"Mr Jeff Brașov — Acasă"},on:{"click":function($event){$event.preventDefault();return _vm.$router.push({ name: 'Home' })}}},[_c('img',{attrs:{"src":require(`@/assets/logos/${_vm.logo}.png`),"alt":"Mr Jeff Brașov"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }